import SVGIcon from "ui/icons/SVGIcon";
import type { IconStatusProps } from "./iconStatusTypes";

export default function IconWarning({ outline = false, fill = "#F55D58", ...props }: IconStatusProps) {
  return (
    <SVGIcon xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
      <circle cx="8" cy="8" r="6" fill={outline ? "none" : fill} stroke={outline ? fill : "none"} />
      <path
        d="M5.5 5.5L8 8M10.5 10.5L8 8M8 8L10.5 5.5M8 8L5.5 10.5"
        stroke={outline ? fill : "white"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SVGIcon>
  );
}
